/* eslint-disable camelcase */
import ReferencialDto from '../../../dto/ReferencialDto'

export default class CityDto extends ReferencialDto {
    constructor(object) {
        super(object)
        this.code = object.id
        this.name = object.name
        this.labelWithCode = `${object.name} [${object.id}]`
        this.situation = object.situation
        this.departmentNumber = object.departmentNumber
        this.area = object.area
        this.countryCode = object.countryCode
        this.x = object.x
        this.y = object.y
        this.projection = object.projection
        this.email = object.email
        this.phone = object.phone
        this.population = object.population
        this.kml = object.kml
        this.climateSector = object.climateSector
        this.siren = object.siren
        this.creationDate = object.creationDate
        this.sispeaCode = object.sispeaCode
        this.address = object.address
        this.addressComplement = object.addressComplement
        this.postalCode = object.postalCode
        this.openHours = object.openHours
        this.waterAgency = object.waterAgency
        this.agency = object.agency
        this.skillAEP = object.skillAEP
        this.codeSkillAEP = object.codeSkillAEP
        this.addressFunction = object.addressFunction
        this.addressCityName = object.addressCityName
        this.link_postalCode = object.link_postalCode || []
        this.link_contacts = object.link_contacts || []
        this.link_populations = object.link_populations || []
        this.headers = ['code', 'name', 'email', 'phone']
    }
}